module.exports = __webpack_public_path__ + "static/media/checklist.dd5fcc75.svg";